import * as _ from 'lodash';
import { UserProfile } from '../api/resources/user-resources';

export class UserExtensions {

  public static parseClaims(userClaims?: any): UserProfile {

    if (!userClaims) {
      return null;
    }

    let roles = userClaims.realm_access?.roles || [];
    if(userClaims.resource_access?.allsafe?.roles){
      roles = _.union(roles, userClaims.resource_access?.allsafe?.roles);
    }
    if(userClaims.resource_access?.account?.roles){
      roles = _.union(roles, userClaims.resource_access?.account?.roles);
    }

    return {
      id: userClaims.sub,
      roles: roles,
      picture: userClaims.picture,
      username: userClaims.preferred_username,
      firstname: userClaims.given_name,
      lastname: userClaims.family_name,
      fullname: userClaims.name,
      mobileNumber: userClaims.mobileNumber,
      emailAddress: userClaims.email
    };
  }
}
